<template>
  <div>
    <v-container fluid class="px-15 pb-10 pt-4">
      <v-row class="ma-0 mt-5 mb-4">
        <v-col class="pa-0 my-4">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #000000;">{{ "Gestión de Tours"}}</div>
          <div style="font-family: 'montserrat-regular'; font-size: 14px;"> {{ "Administra los tours guiados para tus usuarios." }}</div>
        </v-col>
      </v-row>

      <v-row justify="start" align="center" class="d-flex ma-0 mb-4">
        <v-col cols="12" sm="6" md="4" lg="3" class="pa-0 my-4">
          <v-text-field
            v-model="busqueda"
            label="Buscar tour"
            outlined
            clearable
            hide-details
            style="font-family: 'montserrat-medium'; border-radius: 20px;"
          ></v-text-field>
        </v-col>
        <v-col class="d-flex justify-end pa-0 my-4">
          <v-btn
            color="#000000"
            :disabled="loading"
            elevation="8"
            class="white--text ml-4"
            style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-bold'; text-transform: none;"
            @click="openCreateTour()"
          >
            <v-icon left>mdi-plus</v-icon>
            {{ "Nuevo tour" }}
          </v-btn>
        </v-col>
      </v-row>

      <v-data-table
        :search="busqueda"
        style="font-family: 'montserrat-bold';"
        :headers="headers"
        :items="items"
        :loading="loading"
        color="black"
      >
        <template v-slot:item.description="{ item }">
          <div class="description-cell" :title="item.description || ''">
            {{ truncateText(item.description, 90) }}
          </div>
        </template>
        <template v-slot:item.type="{ item }">
          <v-chip
            :color="item.type === 'update' ? '#E0E0E0' : '#C8E6C9'"
            text-color="black"
            class="ma-0"
            style="font-family: 'montserrat-bold';"
          >
            {{ item.type === 'update' ? 'Update' : 'Onboarding' }}
          </v-chip>
        </template>
        <template v-slot:item.active="{ item }">
          <v-chip
            :color="item.active ? '#C8E6C9' : '#E0E0E0'"
            text-color="black"
            class="ma-0"
            style="font-family: 'montserrat-bold';"
          >
            {{ item.active ? 'Active' : 'Inactive' }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="openPreviewTour(item)" v-bind="attrs" v-on="on" icon color="black">
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </template>
            <span>Vista previa</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="openEditTour(item)" v-bind="attrs" v-on="on" icon color="black">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="openDeleteTourDialog(item)"
                v-bind="attrs"
                v-on="on"
                icon
                color="red"
                :disabled="deletingTourId === item.id"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-dialog v-model="dialogCreateTour" max-width="720" persistent>
        <v-card style="border-radius: 20px;">
          <v-card-title class="px-6 py-6" style="font-family: 'montserrat-bold'; font-size: 24px; color: #000000;">
            Crear tour
          </v-card-title>
          
          <v-divider class="mb-4" />
          <v-card-text class="px-6 pb-2">
            <v-form ref="createTourForm" v-model="createTourValid">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="createTour.title"
                    label="Título"
                    hide-details
                    rounded
                    outlined
                    :rules="[rules.required]"
                    counter="255"
                    maxlength="255"
                    style="font-family: 'montserrat-medium';"
                  />
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    v-model="createTour.description"
                    label="Descripción"
                    hide-details
                    rounded
                    outlined
                    rows="4"
                    auto-grow
                    style="font-family: 'montserrat-medium';"
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-select
                    v-model="createTour.type"
                    :items="tourTypes"
                    item-text="text"
                    item-value="value"
                    label="Tipo de tour"
                    hide-details
                    rounded
                    outlined
                    :rules="[rules.required]"
                    style="font-family: 'montserrat-medium';"
                  />
                </v-col>

                <v-col cols="12" md="6" class="d-flex align-center">
                  <v-switch
                    v-model="createTour.active"
                    inset
                    hide-details
                    rounded
                    label="Activo"
                    color="black"
                    style="font-family: 'montserrat-medium'; margin-top: 0px;"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-card-actions class="px-6 pb-6 pt-2 d-flex justify-end">
            <v-btn
              text
              color="black"
              rounded
              style="font-family: 'montserrat-bold'; text-transform: none;"
              :disabled="savingTour"
              @click="closeCreateTour()"
            >
              Cancelar
            </v-btn>

            <v-btn
              color="#000000"
              class="white--text px-5"
              elevation="0"
              :loading="savingTour"
              :disabled="savingTour"
              style="border-radius: 36px; font-family: 'montserrat-bold'; text-transform: none;"
              @click="createProductTour()"
            >
              Crear tour
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogEditTour" max-width="1100" persistent scrollable>
        <v-card style="border-radius: 20px;">
          <v-card-title class="px-6 py-5" style="font-family: 'montserrat-bold'; font-size: 28px;">
            Editar Tour
          </v-card-title>

          <v-card-text class="px-6 pb-6">
            <v-card outlined class="pa-4 mb-6" style="border-radius: 14px;">
              <div class="mb-4" style="font-family: 'montserrat-bold'; font-size: 20px;">Información del Tour</div>

              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="editTour.title" label="Nombre del Tour" hide-details rounded outlined />
                </v-col>
                <v-col cols="12">
                  <v-textarea v-model="editTour.description" label="Descripción" hide-details rounded rows="3" outlined />
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="editTour.type"
                    :items="tourTypes"
                    item-text="text"
                    item-value="value"
                    label="Tipo de tour"
                    rounded
                    hide-details
                    outlined
                  />
                </v-col>
                <v-col cols="12" md="6" class="d-flex align-center">
                  <v-switch v-model="editTour.active" label="Tour Activo" style="margin-top: 0px;" inset color="black" rounded hide-details />
                </v-col>
              </v-row>

              <div class="d-flex justify-end">
                <v-btn
                  color="#000000"
                  class="white--text px-5"
                  rounded
                  :loading="savingEditTour"
                  :disabled="savingEditTour || !editTour.id"
                  @click="saveTourInfo()"
                >
                  Guardar Tour
                </v-btn>
              </div>
            </v-card>

            <div class="d-flex justify-space-between align-center mb-3">
              <div style="font-family: 'montserrat-bold'; font-size: 26px;">
                Pasos del Tour ({{ editTour.steps.length }})
              </div>
              <v-btn color="#000000" class="white--text px-5" @click="addStepRow()" rounded>
                <v-icon left>mdi-plus</v-icon> Agregar Paso
              </v-btn>
            </div>
            <v-card
              v-for="(step, index) in editTour.steps"
              :key="step.id || step.tempId"
              outlined
              class="pa-4 mb-4"
              elevation="4"
              style="border-radius: 14px; border: 1px solid black;"
            >
              <div class="d-flex justify-space-between align-center mb-3">
                <div style="font-family: 'montserrat-bold';">Paso {{ index + 1 }}</div>
                <div>
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small color="red" v-bind="attrs" v-on="on" @click="deleteStep(step, index)"><v-icon>mdi-delete</v-icon></v-btn>
                    </template>
                    <span>Eliminar paso</span>
                  </v-tooltip>
                </div>
              </div>

              <v-text-field v-model="step.title" label="Título" outlined rounded />
              <v-textarea v-model="step.description" label="Descripción" rows="2" outlined rounded />

              <v-file-input
                v-model="step._imageFile"
                label="Imagen del paso"
                accept="image/*"
                outlined
                rounded
                prepend-icon="mdi-image"
                show-size
                @change="onStepImageSelected(step, $event)"
              />

              <div v-if="getStepImage(step)" class="mb-3">
                <v-img
                  :src="getStepImage(step)"
                  max-height="220"
                  contain
                  style="border-radius: 10px; border: 1px solid #E0E0E0;"
                />
                <div class="d-flex justify-end mt-2">
                  <v-btn text small color="red" @click="removeStepImage(step)">
                    Quitar imagen
                  </v-btn>
                </div>
              </div>

              <div class="d-flex justify-end">
                <v-btn
                  color="#000000"
                  class="white--text px-5"
                  rounded
                  :loading="savingSteps[step.id || step.tempId]"
                  @click="saveStep(step, index)"
                >
                  {{ step.id ? "Guardar paso" : "Crear paso" }}
                </v-btn>
              </div>
            </v-card>
          </v-card-text>

          <v-card-actions class="px-6 pb-6 d-flex justify-end">
            <v-btn text color="black" @click="closeEditTour()" class="px-3" rounded>Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogPreviewTour" max-width="900" persistent>
        <v-card style="border-radius: 16px; overflow: hidden;">
          <div v-if="currentPreviewStep">
            <div class="preview-image-wrap">
              <v-img
                :src="currentPreviewStep.image_signed_url || currentPreviewStep.image_url"
                contain
                height="420"
                class="preview-image"
              />
              <v-btn icon class="preview-close-btn" @click="closePreviewTour()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>

            <div class="pa-8">
              <div class="preview-title">{{ currentPreviewStep.title }}</div>
              <div class="preview-description">{{ currentPreviewStep.description }}</div>

              <div class="preview-progress mt-6 mb-6">
                <div
                  v-for="(step, idx) in previewTour.steps"
                  :key="step.id || idx"
                  class="preview-progress-segment"
                  :class="{
                    'active': idx <= previewStepIndex,
                    'current': idx === previewStepIndex
                  }"
                />
              </div>

              <div class="d-flex align-center justify-space-between">
                <v-btn outlined rounded class="px-8" @click="isFirstPreviewStep ? closePreviewTour() : goPreviousPreviewStep()" 
                  style="border-radius: 36px; font-family: 'montserrat-bold'; text-transform: none;">
                  {{ isFirstPreviewStep ? 'Cerrar' : 'Anterior' }}
                </v-btn>

                <div class="preview-counter">
                  {{ previewStepIndex + 1 }} de {{ previewTour.steps.length }}
                </div>

                <v-btn
                  color="#000000"
                  class="white--text px-8"
                  rounded
                  style="border-radius: 36px; font-family: 'montserrat-bold'; text-transform: none;"
                  @click="goNextPreviewStep()"
                >
                  {{ isLastPreviewStep ? 'Finalizar' : 'Siguiente' }}
                </v-btn>
              </div>
            </div>
          </div>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogDeleteTour" max-width="520" persistent>
        <v-card style="border-radius: 16px;">
          <v-card-title style="font-family: 'montserrat-bold';">
            Eliminar tour
          </v-card-title>

          <v-card-text style="font-family: 'montserrat-bold';">
            ¿Seguro que deseas eliminar el tour
            <strong>"{{ tourToDelete?.title || '' }}"</strong>?
            <br />
            Esta acción no se puede deshacer.
          </v-card-text>

          <v-card-actions class="px-6 pb-5 d-flex justify-end">
            <v-btn
              text
              color="black"
              style="font-family: 'montserrat-bold'; text-transform: none;"
              rounded
              :disabled="deletingTour"
              @click="closeDeleteTourDialog()"
            >
              Cancelar
            </v-btn>

            <v-btn
              color="red darken-1"
              class="white--text px-5"
              style="font-family: 'montserrat-bold'; text-transform: none;"
              rounded
              :loading="deletingTour"
              :disabled="deletingTour"
              @click="confirmDeleteTour()"
            >
              Eliminar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
  import moment from "moment";
  export default {
    name: "DashboardView",
    data() {
      return {
        items: [],
        busqueda: "",
        headers: [
          { text: "Titulo", value: "title" },
          { text: "Descripción", value: "description" },
          { text: "Tipo de tour", value: "type" },
          { text: "Pasos", value: "steps_count" },
          { text: "Status", value: "active" },
          { text: "Acciones", value: "actions"}
        ],
        loading: false,
        dialogCreateTour: false,
        dialogEditTour: false,
        dialogDeleteTour: false,
        tourToDelete: null,
        dialogDeleteTour: false,
        tourToDelete: null,
        deletingTourId: null,
        deletingTour: false,
        createTourValid: false,
        savingTour: false,
        savingEditTour: false,
        savingSteps: {},
        createTour: {
          title: "",
          description: "",
          type: null,
          active: true,
        },
        editTour: {
          id: null,
          title: "",
          description: "",
          type: null,
          active: true,
          steps: [],
        },
        tourTypes: [
          { text: "Update", value: "update" },
          { text: "Onboarding", value: "onboarding" },
        ],
        rules: {
          required: (value) => !!value || "Este campo es requerido",
        },
        dialogPreviewTour: false,
        loadingPreviewTour: false,
        previewStepIndex: 0,
        previewTour: {
          id: null,
          title: "",
          steps: [],
        },
      };
    },
    methods: {
      getTours() {
        this.loading = true;
        this.items = [];
        DB.get(`${URI}/api/v1/en/administrator/product-tours`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }).then((response) => {
          this.items = response.data.tours.map((item) => {
            return {
              id: item.id,
              title: item.title,
              description: item.description,
              type: item.type,
              active: item.active,
              steps_count: item.steps_count,
            };
          });
        }).catch((error) => {
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        }).finally(() => {
          this.loading = false;
        });
      },
      truncateText(text, max = 90) {
        if (!text) return "";
        const value = String(text);
        return value.length > max ? `${value.slice(0, max)}...` : value;
      },
      formatMoney(value) {
        let multiplied = value * 100;
        let rounded = Math.round(multiplied);
        let formattedNumber = rounded / 100;
        return new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(formattedNumber);
      },
      formatDate(date) {
        if (this.selectLanguage === "sp") {
          moment.locale("es");
        } else {
          moment.locale("en");
        }
        let newDate = moment(date);
        let formattedDate = newDate.format("MMMM D, YYYY");
        return formattedDate;
      },
      resetCreateTourForm() {
        this.createTour = {
          title: "",
          description: "",
          type: null,
          active: true,
        };

        if (this.$refs.createTourForm) {
          this.$refs.createTourForm.resetValidation();
        }
      },
      openCreateTour() {
        this.resetCreateTourForm();
        this.dialogCreateTour = true;
      },
      closeCreateTour() {
        this.dialogCreateTour = false;
        this.resetCreateTourForm();
      },
      createProductTour() {
        if (!this.$refs.createTourForm.validate()) {
          return;
        }

        this.savingTour = true;

        DB.post(
          `${URI}/api/v1/en/administrator/product-tours/createTour`,
          {
            title: this.createTour.title.trim(),
            description: this.createTour.description ? this.createTour.description.trim() : null,
            type: this.createTour.type,
            active: this.createTour.active,
          },
          {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : ""
            }
          }
        ).then((response) => {
          this.mixSuccess(response.data.message);
          this.closeCreateTour();
          this.getTours();
        }).catch((error) => {
          if (error.response?.data?.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(
            error.response?.data?.message || "Error al crear el tour",
            error.response?.status || 500
          );
        }).finally(() => {
          this.savingTour = false;
        });
      },
      openEditTour(item) {
        this.resetEditTourForm();
        this.dialogEditTour = true;
        this.loadingEditTour = true;

        DB.get(`${URI}/api/v1/en/administrator/product-tours/${item.id}`, {
          headers: this.authHeaders(),
        }).then((response) => {
          const tour = response.data.tour;
          this.editTour = {
            id: tour.id,
            title: tour.title || "",
            description: tour.description || "",
            type: tour.type || null,
            active: !!tour.active,
            steps: (tour.steps || [])
              .sort((a, b) => a.step_order - b.step_order)
              .map((step) => ({
                ...step,
                _imageFile: null,
                image_preview_url: step.image_signed_url || null,
                remove_image: false,
              })),
          };
        }).catch((error) => {
          this.mixError(error.response?.data?.message || "Error al cargar el tour", error.response?.status || 500);
          this.closeEditTour();
        }).finally(() => {
          this.loadingEditTour = false;
        });
      },
      closeEditTour() {
        this.dialogEditTour = false;
        this.resetEditTourForm();
      },
      saveTourInfo() {
        if (!this.editTour.id) return;
        this.savingEditTour = true;

        DB.put(
          `${URI}/api/v1/en/administrator/product-tours/${this.editTour.id}`,
          {
            title: this.editTour.title?.trim(),
            description: this.editTour.description?.trim() || null,
            type: this.editTour.type,
            active: this.editTour.active,
          },
          { headers: this.authHeaders() }
        ).then((response) => {
          this.mixSuccess(response.data.message || "Tour actualizado");
          this.getTours();
        }).catch((error) => {
          this.mixError(error.response?.data?.message || "Error al actualizar tour", error.response?.status || 500);
        }).finally(() => {
          this.savingEditTour = false;
        });
      },
      addStepRow() {
        this.editTour.steps.push({
          tempId: `tmp_${Date.now()}_${Math.random()}`,
          id: null,
          title: "",
          description: "",
          image_url: null,
          image_signed_url: null,
          image_preview_url: null,
          _imageFile: null,
          remove_image: false,
          step_order: this.editTour.steps.length + 1,
        });
      },
      getStepImage(step) {
        return step.image_preview_url || step.image_signed_url || null;
      },
      onStepImageSelected(step, file) {
        const selected = Array.isArray(file) ? file[0] : file;
        step._imageFile = selected || null;
        step.remove_image = false;

        if (selected) {
          step.image_preview_url = URL.createObjectURL(selected);
        }
      },
      removeStepImage(step) {
        step._imageFile = null;
        step.remove_image = true;
        step.image_preview_url = null;
        step.image_signed_url = null;
        step.image_url = null;
      },
      buildStepFormData(step) {
        const formData = new FormData();
        formData.append("title", step.title.trim());
        formData.append("description", step.description?.trim() || "");
        formData.append("step_order", String(step.step_order || 1));

        if (step._imageFile) {
          formData.append("image", step._imageFile);
        }

        if (step.remove_image) {
          formData.append("remove_image", "true");
        }

        return formData;
      },
      deleteStep(step, index) {
        if (!step.id) {
          this.editTour.steps.splice(index, 1);
          return;
        }

        DB.delete(
          `${URI}/api/v1/en/administrator/product-tours/${this.editTour.id}/steps/${step.id}`,
          { headers: this.authHeaders() }
        ).then((response) => {
          this.mixSuccess(response.data.message || "Paso eliminado");
          this.editTour.steps.splice(index, 1);
          this.getTours();
        }).catch((error) => {
          this.mixError(error.response?.data?.message || "Error al eliminar paso", error.response?.status || 500);
        });
      },
      saveStep(step, index) {
        if (!this.editTour.id) return;
        if (!step.title || !step.title.trim()) {
          this.mixError("El título del paso es requerido", 400);
          return;
        }

        const key = step.id || step.tempId;
        this.$set(this.savingSteps, key, true);

        const formData = this.buildStepFormData(step);

        const request = step.id
          ? DB.put(
              `${URI}/api/v1/en/administrator/product-tours/${this.editTour.id}/steps/${step.id}`,
              formData,
              { headers: this.authHeaders() }
            )
          : DB.post(
              `${URI}/api/v1/en/administrator/product-tours/${this.editTour.id}/steps`,
              formData,
              { headers: this.authHeaders() }
            );

        request.then((response) => {
          const saved = response.data.step;
          this.$set(this.editTour.steps, index, {
            ...saved,
            _imageFile: null,
            image_preview_url: saved.image_signed_url || null,
            remove_image: false,
          });
          this.mixSuccess(response.data.message || "Paso guardado");
        }).catch((error) => {
          this.mixError(error.response?.data?.message || "Error al guardar paso", error.response?.status || 500);
        }).finally(() => {
          this.$set(this.savingSteps, key, false);
          this.getTours();
        });
      },
      authHeaders() {
        return {
          Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : "",
        };
      },
      resetEditTourForm() {
        this.editTour = {
          id: null,
          title: "",
          description: "",
          type: null,
          active: true,
          steps: [],
        };
        this.savingSteps = {};
      },
      openPreviewTour(item) {
        this.dialogPreviewTour = true;
        this.loadingPreviewTour = true;
        this.previewStepIndex = 0;
        this.previewTour = { id: null, title: "", steps: [] };

        DB.get(`${URI}/api/v1/en/administrator/product-tours/${item.id}`, {
          headers: this.authHeaders(),
        }).then((response) => {
          const tour = response.data.tour;
          this.previewTour = {
            id: tour.id,
            title: tour.title || "",
            steps: (tour.steps || [])
              .sort((a, b) => a.step_order - b.step_order)
              .map((step) => ({
                ...step,
                image_signed_url: step.image_signed_url || null,
              })),
          };
        }).catch((error) => {
          this.mixError(error.response?.data?.message || "Error al cargar vista previa", error.response?.status || 500);
          this.closePreviewTour();
        }).finally(() => {
          this.loadingPreviewTour = false;
        });
      },
      closePreviewTour() {
        this.dialogPreviewTour = false;
        this.previewStepIndex = 0;
        this.previewTour = { id: null, title: "", steps: [] };
      },
      goNextPreviewStep() {
        if (this.isLastPreviewStep) {
          this.closePreviewTour();
          return;
        }
        this.previewStepIndex += 1;
      },
      goPreviousPreviewStep() {
        if (this.isFirstPreviewStep) {
          return;
        }
        this.previewStepIndex -= 1;
      },
      openDeleteTourDialog(item) {
        if (!item?.id) return;
        this.tourToDelete = item;
        this.dialogDeleteTour = true;
      },
      closeDeleteTourDialog() {
        this.dialogDeleteTour = false;
        this.tourToDelete = null;
      },
      confirmDeleteTour() {
        if (!this.tourToDelete?.id) return;

        this.deletingTour = true;
        this.deletingTourId = this.tourToDelete.id;

        DB.delete(`${URI}/api/v1/en/administrator/product-tours/${this.tourToDelete.id}`, {
          headers: this.authHeaders(),
        })
          .then((response) => {
            this.mixSuccess(response.data?.message || "Tour eliminado exitosamente");
            this.closeDeleteTourDialog();
            this.getTours();
          })
          .catch((error) => {
            this.mixError(
              error.response?.data?.message || "Error al eliminar el tour",
              error.response?.status || 500
            );
          })
          .finally(() => {
            this.deletingTour = false;
            this.deletingTourId = null;
          });
      },
    },
    computed: {
      currentPreviewStep() {
        return this.previewTour.steps?.[this.previewStepIndex] || null;
      },
      isLastPreviewStep() {
        return !this.previewTour.steps?.length || this.previewStepIndex === this.previewTour.steps.length - 1;
      },
      isFirstPreviewStep() {
        return !this.previewTour.steps?.length || this.previewStepIndex === 0;
      },
    },
    beforeMount() {
      this.getTours();
    },
  };
</script>

<style>
.description-cell {
  max-width: 320px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.preview-image-wrap {
  position: relative;
  background: #f5f5f5;
}
.preview-image {
  width: 100%;
}
.preview-close-btn {
  position: absolute !important;
  top: 14px;
  right: 14px;
  background: #ffffff !important;
}
.preview-title {
  font-family: 'montserrat-bold';
  font-size: 46px;
  color: #1a2238;
}
.preview-description {
  margin-top: 14px;
  font-family: 'montserrat-medium';
  font-size: 22px;
  line-height: 1.5;
  color: #4f5b72;
}
.preview-progress {
  display: grid;
  align-items: center;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}
.preview-progress-segment {
  height: 8px;
  border-radius: 8px;
  background: #d9dde5;
  transition: all 0.3s ease;
}
.preview-progress-segment.active {
  background: #8ec5ff;
}
.preview-progress-segment.current {
  height: 14px;
  background: #2f66ff;
}
.preview-counter {
  font-family: 'montserrat-bold';
  font-size: 28px;
  color: #6f7788;
}
</style>
